<script>
  import ProductItem from '@components/List/ProductItem'

  export default {
    components: {
      ProductItem,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      type: {
        type: String,
        default: 'carousel',
        /*  validator(value) {
         return ['carousel', 'grid'].includes(value)
         }, */
      },
      linkType: {
        type: String,
        default: 'brand',
        validator(value) {
          return ['brand',
            'list'].includes(value)
        },
      },
    },
    data() {
      return {
        swiperRative: {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 38,
          speed: 200,
          navigation: {
            nextEl: `.swiper-button-next-rative`,
            prevEl: `.swiper-button-prev-rative`,
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
            },
          },
        },
      }
    },
  }
</script>
<template>
  <div :class="$style.ArticleRative">
    <div class="container section">
      <h2 class="ArticleRative__title">相關產品</h2>
      <div class="ArticleRative__content">
        <swiper ref="swiperRative" :options="swiperRative">
          <template v-for="(item, index) in list">
            <swiper-slide :key="index">
              <ProductItem :key="index" :data="item" :link-type="linkType"/>
            </swiper-slide>
          </template>
        </swiper>
        <div slot="button-prev" class="swiper-button-prev swiper-button-prev__dark swiper-button-prev-rative">
          <i class="fal fa-angle-left"></i>
        </div>
        <div slot="button-next" class="swiper-button-next swiper-button-next__dark swiper-button-next-rative">
          <i class="fal fa-angle-right"></i>
        </div>
        <!-- <template v-for="(item, index) in list">
       
      </template> -->
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
  .ArticleRative {
    // padding-top: 8rem;
    // padding-bottom: 10.5rem;
    background: $color-gray-2;

    :global {
      .listProductItem__content {
        margin-top: 2rem;
        margin-bottom: 2rem;
      }

      .swiper-container {
        width: 85%;
        padding-right: 2rem;
        padding-left: 2rem;
      }

      .ArticleRative {
        &__title {
          margin-bottom: 1.75rem;
          font-size: 2.5rem;
          text-align: center;
        }

        &__content {
          position: relative;
        }
      }
    }
  }
</style>
